export const THREE_PL = '3pl_company'
export const RETAILER = 'retailer'
export const MARKETPLACE = 'marketplace'

export const TYPES = {
  [THREE_PL]: '3PL Company',
  [RETAILER]: 'Retailer',
  [MARKETPLACE]: 'Marketplace'
}
